import React, { useEffect, useRef, useState } from "react";
import "./../../../assets/css/student/StudentStories/StudentSuccess.css";

const reviews = [
  {
    id: 1,
    name: "Ali Rehman",
    grade: "Grade 4",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=11",
    rating: 5,
    review:
      "My mentor helps me practice concepts with fun examples. I even beat my older brother in coding now!",
    tags: ["Gamified Learning", "Mental Math"],
  },
  {
    id: 2,
    name: "Sana",
    grade: "Grade 10",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=5",
    rating: 5,
    review:
      "Web development used to be boring… now I explore it like a story – with projects, guidance, and questions.",
    tags: ["Social Studies", "Interactive History"],
  },
  {
    id: 3,
    name: "Javeria",
    grade: "Grade 6",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=8",
    rating: 4,
    review:
      "My mentor teaches me through puzzles – it's never boring now. I look forward to every session!",
    tags: ["Engaging", "Geography"],
  },
  {
    id: 4,
    name: "Alishba",
    grade: "Grade 9",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=9",
    rating: 5,
    review:
      "I went from failing maths to topping my class in just 3 months. The mentors here are incredible!",
    tags: ["Mathematics", "Problem Solving"],
  },
  {
    id: 5,
    name: "Hamza",
    grade: "Grade 9",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=12",
    rating: 5,
    review:
      "The personalized sessions made all the difference. My confidence grew every single week.",
    tags: ["Confidence", "Science"],
  },
  {
    id: 6,
    name: "Kinza",
    grade: "Grade 7",
    country: "Pakistan",
    image: "https://i.pravatar.cc/150?img=47",
    rating: 4,
    review:
      "I love how my mentor explains everything step by step. I never feel left behind in class now.",
    tags: ["Step-by-step", "English"],
  },
];

const Stars = ({ count }) => (
  <div className="sss-stars">
    {[1, 2, 3, 4, 5].map((s) => (
      <span key={s} className={s <= count ? "sss-star filled" : "sss-star"}>
        ★
      </span>
    ))}
  </div>
);

const StudentSuccessStories = () => {
  const trackRef = useRef(null);
  const [current, setCurrent] = useState(0);
  const total = reviews.length;
  const visible = 3; // cards visible at once on desktop

  const slideTo = (idx) => {
    const bounded = Math.max(0, Math.min(idx, total - visible));
    setCurrent(bounded);
  };

  const prev = () => slideTo(current - 1);
  const next = () => slideTo(current + 1);

  // Auto-slide every 4s
  useEffect(() => {
    const id = setInterval(() => {
      setCurrent((c) => (c >= total - visible ? 0 : c + 1));
    }, 4000);
    return () => clearInterval(id);
  }, [total, visible]);

  // Apply transform
  useEffect(() => {
    if (!trackRef.current) return;
    const cardW = trackRef.current.children[0]?.offsetWidth || 0;
    const gap = 24;
    trackRef.current.style.transform = `translateX(-${current * (cardW + gap)}px)`;
  }, [current]);

  return (
    <section className="sss-section">
      {/* Background decoration */}
      <div className="sss-bg-blob sss-blob1" />
      <div className="sss-bg-blob sss-blob2" />

      <div className="sss-container">
        {/* Heading */}
        <div className="sss-heading-wrap">
          <div className="sss-left-heading">
            <div className="sss-tag">💬 Testimonials</div>
            <h2 className="sss-main-title">
              Student
              <br />
              <span className="sss-accent">Success</span>
              <br />
              Stories
            </h2>
            <p className="sss-desc">
              Real voices from students worldwide who achieved more with our
              mentors.
            </p>

            {/* Arrows */}
            <div className="sss-arrows">
              <button
                className="sss-arrow"
                onClick={prev}
                disabled={current === 0}
              >
                ←
              </button>
              <button
                className="sss-arrow"
                onClick={next}
                disabled={current >= total - visible}
              >
                →
              </button>
            </div>

            {/* Dots */}
            <div className="sss-dots">
              {Array.from({ length: total - visible + 1 }).map((_, i) => (
                <button
                  key={i}
                  className={`sss-dot ${current === i ? "sss-dot-active" : ""}`}
                  onClick={() => slideTo(i)}
                />
              ))}
            </div>
          </div>

          {/* Slider */}
          <div className="sss-slider-wrap">
            <div className="sss-track-outer">
              <div className="sss-track" ref={trackRef}>
                {reviews.map((r, idx) => (
                  <div
                    key={r.id}
                    className={`sss-card ${idx === current + 1 ? "sss-card-featured" : ""}`}
                  >
                    <div className="sss-card-top">
                      <img src={r.image} alt={r.name} className="sss-avatar" />
                      <div>
                        <p className="sss-name">{r.name}</p>
                        <p className="sss-grade">{r.grade}</p>
                        <p className="sss-country">{r.country}</p>
                      </div>
                    </div>

                    <Stars count={r.rating} />

                    <p className="sss-review">"{r.review}"</p>

                    <div className="sss-tags">
                      {r.tags.map((t) => (
                        <span key={t} className="sss-tag-pill">
                          {t}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudentSuccessStories;
